/**
 * @desc 获取商户固定金额码信息
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** fixedAmountQrcode */
  fixedAmountQrcode: string
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/merchant/fixedAmountQrcode',
    params,
    method: 'get',
  })
}
